import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Formik, Form } from "formik";
import { Button, Tab, Tabs } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useAlert, useGet, useRest } from "react-common";
import { AsyncSelectField, FallbackMessage, UserDisplay } from 'ds-form';
import { transformUser } from "../utils/userUtils";
import '../styles/SlideshowEditModal.css';
import { useState } from 'react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import AccessCard from './AccessCard';
import { ROLE_AUTHOR, ROLE_OWNER, ROLE_PRESENTER, ROLE_READER } from '../utils/commonUtils';


const TabPanel = ({ children, value, index, style, ...other }) => {
    return (
        <div
            role="tabpanel"
            aria-labelledby={`change-tab-${index}`}
            style={{ ...style, display: value === index ? "block" : "none" }}
            {...other}
        >
            {children}
        </div>
    );
};


const SlideshowEditModal = ({ slideshow, isOpenSlideshowEdit, setIsOpenSlideshowEdit, isOwner }) => {

    const handleClose = () => setIsOpenSlideshowEdit(false);
    const { t } = useTranslation();
    const { postData } = useRest();
    const [currentTab, setCurrentTab] = useState(0);
    const alert = useAlert();

    

    const [accesses = [], /*accessesLoading*/, refreshAccesses] = useGet("Accesses", {
        params : {
            slideshowID: slideshow.id
        },
        transform: (res) => {
            return res.records || [];
        }
    });

    const tabs = [
        {
            icon: <PersonAddIcon style={{ fontSize: "32px" }} />,
            id: "access"
        },
        {
            icon: <SlideshowIcon style={{ fontSize: "32px" }} />,
            id: "presenters"
        },
    ];

    return (
        <div>
            <Modal
                open={isOpenSlideshowEdit}
                onClose={handleClose}
            >
                <Box className="boxContainer" >

                    <Tabs value={currentTab} 
                        onChange={(e, newValue) => {setCurrentTab(newValue)}}
                        centered
                    >
                        {tabs.map((tab) => (
                            <Tab
                                title={tab.name}
                                key={tab.id}
                                icon={tab.icon}
                            />
                        ))}
                    </Tabs>
   
                    <TabPanel value={currentTab} index={0}>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                userID: null,
                                slideshowID: slideshow.id
                            }}
                            validate={(values) => {
                                const errors = {};
                                return errors;
                            }}
                            onSubmit={(values, actions) => {
                                const transformValues = {...values, userID: values.userID.id, roles: 4}
                                postData("Access", transformValues)
                                    .then(() => {
                                        refreshAccesses();
                                        alert.success("Form submission succeed");
                                        actions.setSubmitting(false);
                                    })
                                    .catch((e) => {
                                        alert.error("Form submission failed");
                                        actions.setSubmitting(false);
                                    });
                            }}
                        >
                            <Form className="basicForm">
                                {isOwner &&
                                    <div className="searchUser">
                                        <AsyncSelectField
                                            placeholder={t("addAccess")}
                                            className="userSelect"
                                            name="userID"
                                            dataKey="Users"
                                            minLength={2}
                                            useGetOptions={{
                                                transform: (res) => res.records.map(transformUser)
                                            }}
                                            renderReadonlyValue={(val) => {
                                                if (!val || !val.value) {
                                                    return <FallbackMessage>No users</FallbackMessage>
                                                }
                                                return <UserDisplay user={val} />
                                            }}
                                        /> 
                                        <Button className="userSelectButton" type="submit" variant="contained" color="primary">{t('add')}</Button>    
                                    </div>
                                }

                                <div className="accessesContainer">
                                    {accesses.filter(access => ((access.roles & ROLE_OWNER) === ROLE_OWNER) || ((access.roles & ROLE_AUTHOR) === ROLE_AUTHOR) || ((access.roles & ROLE_READER) === ROLE_READER))
                                        .map((access) => (
                                            <AccessCard 
                                                key={access.id}
                                                access={access} 
                                                user={access.user} 
                                                slideshowID={slideshow.id} 
                                                refreshAccesses={refreshAccesses}
                                                isOwner={isOwner}
                                                accessCardPresenter={false}
                                                roles={1}
                                            />
                                    ))}    
                                </div>
                            </Form>
                        </Formik>
                    </TabPanel>

                    <TabPanel value={currentTab} index={1}>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                userID: null,
                                slideshowID: slideshow.id
                            }}
                            validate={(values) => {
                                const errors = {};
                                return errors;
                            }}
                            onSubmit={(values, actions) => {
                                const transformValues = {...values, userID: values.userID.id, roles: 8}
                                postData("Access", transformValues)
                                    .then(() => {
                                        refreshAccesses();
                                        alert.success("Form submission succeed");
                                        actions.setSubmitting(false);
                                    })
                                    .catch((e) => {
                                        alert.error("Form submission failed");
                                        actions.setSubmitting(false);
                                    });
                            }}
                        >
                            <Form className="basicForm">
                                {isOwner &&
                                    <div className="searchUser">
                                        <AsyncSelectField
                                            placeholder={t("addPresenter")}
                                            className="userSelect"
                                            name="userID"
                                            dataKey="Users"
                                            minLength={2}
                                            useGetOptions={{
                                                transform: (res) => res.records.map(transformUser)
                                            }}
                                            renderReadonlyValue={(val) => {
                                                if (!val || !val.value) {
                                                    return <FallbackMessage>No users</FallbackMessage>
                                                }
                                                return <UserDisplay user={val} />
                                            }}
                                        /> 
                                        <Button className="userSelectButton" type="submit" variant="contained" color="primary">{t('add')}</Button>    
                                    </div>
                                }
                                
                                <div className="accessesContainer">
                                    {accesses.filter(access => (access.roles & ROLE_PRESENTER) === ROLE_PRESENTER).map((access) => (
                                        <AccessCard 
                                            access={access} 
                                            user={access.user} 
                                            slideshowID={slideshow.id} 
                                            refreshAccesses={refreshAccesses}
                                            isOwner={isOwner}
                                            accessCardPresenter={true}
                                            roles={ROLE_PRESENTER}
                                        />
                                    ))}    
                                </div>   
                            </Form>
                        </Formik>
                    </TabPanel>
                </Box>
            </Modal>
        </div>
    );
}

export default SlideshowEditModal;